const regExpPhone = /^(\d{0}|\d{9})$/;

export function isValidPhone(value) {
  return regExpPhone.test(value);
}

export function isValidNif(value) {
  // This only serves to improve user experience. Do NOT use this function without an accompanying check on the API endpoint.

  if (value === "") {
    return true;
  }

  if (!regExpPhone.test(value)) {
    return false;
  }
  if (parseInt(value[0], 10) === 0) {
    return false;
  }

  const nifWeightedSum = [...value]
    .slice(0, 8)
    .reduce((sum, x, i) => sum + (9 - i) * parseInt(x, 10), 0);
  const nifRest11 = nifWeightedSum % 11;

  if (nifRest11 === 0 || nifRest11 === 1) {
    if (parseInt(value[8], 10) !== 0) {
      return false;
    }
  } else if (11 - nifRest11 !== parseInt(value[8], 10)) {
    return false;
  }

  return true;
}

export function objectsArrayAreEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }

  return array1.every((obj1, index) => {
    const obj2 = array2[index];
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every((key) => obj1[key] === obj2[key]);
  });
}

export function arraysAreEqual(array1, array2) {
  if (array1.length !== array2.length) return false;

  return array1.every((item) => array2.includes(item));
}

export default {
  isValidPhone,
  isValidNif,
  objectsArrayAreEqual,
  arraysAreEqual,
};
